module.exports = "<div class=\"footer\" *ngIf=\"loginService.isLogged\">\n  Ixio by iProspect R&D 2019 (version 2.0.0)\n</div>\n"